module.exports = __webpack_public_path__ + "img/10.b687d258.jpg";